import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Route, Switch } from 'react-router';
import * as usersActions from 'Store/users/actions';
import * as reducers from 'Store/reducers';

import Loading from 'Components/Loading';
import ContentFrame from 'Components/ContentFrame';
import SectionHeader from 'Components/SectionHeader';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import SidebarNav from 'Components/SidebarNav';
import Error from 'Containers/Error';
import { ROUTES } from 'Settings/route-strings';

import ChangePasswordForm from './ChangePasswordForm';
import SubscriptionSettings from './SubscriptionSettings';
import EditUserForm from 'Containers/EditUserForm';

function UserSettings(props) {
  const { activeUser, activeSchool } = props;
  if (!activeUser || !activeSchool) return <Loading />;
  const { isAdmin, roles } = activeUser;
  const schoolUserIsAdminOf = roles[0][0];

  const showSubscriptionLink =
    isAdmin && schoolUserIsAdminOf === activeSchool.id;

  const sideBarLinks = [
    {
      id: 'account',
      label: <ConnectedFormattedMessage id="settings_sidebar.account_label" />,
      route: ROUTES.SETTINGS_ACCOUNT,
    },
    {
      id: 'password',
      label: <ConnectedFormattedMessage id="settings_sidebar.password_label" />,
      route: ROUTES.SETTINGS_CHANGE_PASSWORD,
    },
  ];

  if (showSubscriptionLink) {
    sideBarLinks.push({
      id: 'subscription',
      label: (
        <ConnectedFormattedMessage id="settings_sidebar.subscription_label" />
      ),
      route: ROUTES.SETTINGS_SUBSCRIPTION,
    });
  }

  return (
    <main className="Page__content">
      <ContentFrame
        size="large"
        pageType="with-side-nav"
        sidebar={
          <SidebarNav
            activeSchool={activeSchool}
            activeUser={activeUser}
            items={sideBarLinks}
          />
        }
      >
        <Switch>
          <Route
            path={ROUTES.SETTINGS_CHANGE_PASSWORD}
            component={() => <ChangePasswordForm />}
          />
          <Route
            path={ROUTES.SETTINGS_ACCOUNT}
            component={() => (
              <div>
                <SectionHeader
                  title={<ConnectedFormattedMessage id="account_page.title" />}
                  type="static-modal"
                />
                <EditUserForm user={activeUser} />
              </div>
            )}
          />
          {showSubscriptionLink && (
            <Route
              path={ROUTES.SETTINGS_SUBSCRIPTION}
              component={() => <SubscriptionSettings />}
            />
          )}
          <Route component={() => <Error type="pageNotFound" code={404} />} />
        </Switch>
      </ContentFrame>
    </main>
  );
}

const mapStateToProps = (state) => {
  return {
    activeUser: reducers.getActiveUser(state),
    activeSchool: reducers.getActiveSchool(state),
  };
};

export default withRouter(connect(mapStateToProps, usersActions)(UserSettings));
